import React, { useState, useCallback,useEffect } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { pathOr } from 'ramda';
import { useDispatch, useSelector } from "react-redux";
import { getDetailView, getReportsDetailView,getEmailsDetailView} from "../../store/actions/detail.actions";
import { getListView} from '../../store/actions/module.actions';
import {Page, EmailFolders, EmailList, EmailDetails } from './components';
import {Error,SkeletonShell} from "../../components";
import { QuickComposeEmail } from "./components";
import { getEmailCreateView } from "../../store/actions/emails.actions";
import EmailSettings from "./components/EmailSettings";
import { FolderOpen } from '@material-ui/icons';
import  { Redirect } from 'react-router-dom'

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    display: 'flex',
    overflow: 'hidden',
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    '@media (max-width: 780px)': {
      '& $emailFolders, & $emailList, & $emailDetails': {
        flexBasis: '100%',
        width: '100%',
        maxWidth: 'none',
        flexShrink: '0',
        transition: 'transform .5s ease',
        transform: 'translateX(0)'
      }
    }
  },
  openFolder: {
    '@media (max-width: 780px)': {
      '& $emailFolders, & $emailList, & $emailDetails': {
        transform: 'translateX(-100%)'
      }
    }
  },
  emailFolders: {
    flexBasis: 250,
    flexShrink: 0,
    flexGrow: 0,
    borderRight: `1px solid ${theme.palette.divider}`
  },
  emailList: {
    flexGrow: 1,
    minHeight:'100vh',
    background:theme.palette.background.paper,
  },
  emailDetails: {
    flexGrow: 1,
    background: theme.palette.background.paper,
  }
}));

const Mail = ({ACLAccess,dataLabels,data,module,moduleLabel,isLoading,meta,dateFormat,folderDetails,selectedFolder,listViewWhere,page,setPageNo,sortBy,sortOrder,lastListViewSort,rowsPerPage,changePageOrSort}) => {
  const classes = useStyles();
  //console.log("Maildata",data);
  const dispatch = useDispatch();
  //const { module, id,uid,msgno } = useParams();
  const [openFolder, setOpenFolder] = useState(false);
  const [openFolderId, setOpenFolderId] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState(null);
const [emailModalVisible, setEmailModalVisible] = useState(false);
const [emailModal, setEmailModal] = useState({visible:false,to:""});
const [emailSettingModal, setEmailSettingModal] = useState(false);
const [value, setValue] = useState(0);
const [emailRecords, setEmailRecords] = useState(data);
const [id, setId] = useState("");
const [uid, setUid] = useState("");
const [msgno, setMsgno] = useState("");
const [crmEmailId, setCrmEmailId] = useState("");
const [isSubpanelUpdated, setIsSubpanelUpdated] = useState(false);
  const { detailFilterViewData, detailViewReportLoading, detailViewReportFilterLoading, detailViewLoading, detailViewError, detailViewTabData, detailViewGroupTabData, detailGroupViewLoading } = useSelector(
    (state) => state.detail,
  );

  const config = useSelector((state) => state.config);
  const { listViewLoading, listViewError, listViewTabData, selectedModule } = useSelector((state) => state.modules);
  const { emailCreateViewLoading } = useSelector((state) => state.emails);

  // const email = pathOr([], ['data', 'templateMeta', 'data','attributes'], listViewTabData['Emails']);
   const [listViewMeta,setListViewMeta] = useState(meta);
  // const rowsPerPage = pathOr(20, ['config', 'list_max_entries_per_page'], config);

  // useEffect(() => {
  //   let mounted = true;

  //   // const fetchEmails = () => {
  //   //   axios.get('/api/mail').then(response => {
  //   //     if (mounted) {
  //   //       setEmails(response.data.emails);
  //   //     }
  //   //   });
  //   // };

  //   // fetchEmails();

  //   return () => {
  //     mounted = false;
  //   };
  // }, []);

  const handleFolderOpen = async (id) => {
    setSelectedEmail(null);
    setOpenFolder(true);
    setOpenFolderId(id);
    setPageNo(0);
    await dispatch(getListView(module, 0, rowsPerPage,'','',id)).then((res)=>{
      setEmailRecords(pathOr([], ['data', 'data','templateMeta','data'], res));
      setListViewMeta(pathOr([], ['data','meta'], res));
    }); 
    
  };

  // const getDetailViewData = useCallback(() => {
  //   dispatch(getEmailsDetailView(module, id,msgno,uid)).then((res)=>{
  //     let data = pathOr([], ['data', 'data','templateMeta'], res);
  //     setSelectedEmail(data);
  //   });
  //   if(isSubpanelUpdated){
  //     setValue(value)
  //     setIsSubpanelUpdated(false)
  //   }
    
  // }, [msgno,uid, isSubpanelUpdated]);

  const handleFolderClose = () => {
    setOpenFolder(false);
  };
  const handleComposeEmailPopup = (type,data)=>{
    dispatch(getEmailCreateView()).then(function (res) {
      if(type==='reply')
      {
        setEmailModal({to:data.from_addr_name || "", name:`RE:${data.name}`});
      }
      else if(type==='replyAll')
      {
        setEmailModal({to:data.from_addr_name ||"",cc:data.cc_addrs_names||"",bcc:data.bcc_addrs_names||"",name:`RE:${data.name}`});
      }
      else if(type==='forward')
      {
        setEmailModal({to:"",name:`FWD:${data.name}`,description_html:data.description_html});
      }
      else{
        setEmailModal({to:""});
      }
      
      setEmailModalVisible(!emailModalVisible);
    });    
  }

  const handleEmailOpen = async (id,email,crmEmailId) => {    
    setId(id);
    setMsgno(email.msgno);
    setUid(email.uid);
    setCrmEmailId(crmEmailId);
    //getDetailViewData("Emails", id,email.msgno,email.uid,crmEmailId);
    //console.log("email",email);
    //console.log("crmEmailId",crmEmailId);
    
    await dispatch(getEmailsDetailView("Emails", email.inbound_email_record,email.msgno,email.uid,crmEmailId)).then((res)=>{
      let data = pathOr([], ['data', 'data','templateMeta'], res);
      setSelectedEmail(data);
      emailRecords.map((emailObj,key)=>{
      if(email.uid === emailObj.attributes.uid)
      {
        emailRecords[key].attributes.status="read";
      }})  
    });
    setEmailRecords(emailRecords);    
  };

  const handleEmailClose = () => {
    setSelectedEmail(null);
    
  };


	useEffect(()=>{
    setSelectedEmail(null);
		setEmailRecords(emailRecords)
  },[emailRecords]);

  useEffect(()=>{
    setSelectedEmail(null);
		setListViewMeta(listViewMeta)
  },[listViewMeta]);

  if (detailViewError) {
    return <Error description={detailViewError} title="Error"/>;
  }
  
  return (
    <Page
      className={clsx({
        [classes.root]: true,
        [classes.openFolder]: openFolder
      })}
      title="Mail"
    >
      <EmailFolders
        className={classes.emailFolders}
        onFolderOpen={handleFolderOpen}
        folderData={folderDetails}
        selectedFolder = {selectedFolder}
        handleComposeEmailPopup={handleComposeEmailPopup}
        emailCreateViewLoading={emailCreateViewLoading}
      />   
      {(detailViewLoading && (!Object.keys(detailViewTabData).length || !Object.keys(detailFilterViewData).length))?
      <SkeletonShell layout="DetailView" />:
        <>{selectedEmail?<EmailDetails
        className={classes.emailDetails}
        loader={<SkeletonShell layout="DetailView" />}
        email={selectedEmail}
        onEmailClose={handleEmailClose}
        handleComposeEmailPopup={handleComposeEmailPopup}
        emailCreateViewLoading={emailCreateViewLoading}
        setIsSubpanelUpdated={setIsSubpanelUpdated}
        setValue={setValue}
        value={value}
        selectedEmail={selectedEmail}
        setSelectedEmail={setSelectedEmail}
        onBack={handleFolderClose}
        onEmailOpen={handleEmailOpen}
        setEmailSettingModal={setEmailSettingModal}
        meta={listViewMeta}
        listViewWhere={listViewWhere}
        page={page}
        sortBy={sortBy}
        sortOrder={sortOrder}
        lastListViewSort={lastListViewSort}
        rowsPerPage={rowsPerPage}
        changePageOrSort={changePageOrSort}
        selectedFolder = {selectedFolder}
      />:""}</>}
    {!selectedEmail?
      <EmailList
          loader={listViewLoading}
          className={classes.emailList}
          emailRecords={emailRecords}
          setEmailRecords={setEmailRecords}
          onBack={handleFolderClose}
          onEmailOpen={handleEmailOpen}
          setEmailSettingModal={setEmailSettingModal}
          selectedEmail={selectedEmail}
          setSelectedEmail={setSelectedEmail}
          meta={listViewMeta}
          listViewWhere={listViewWhere}
          page={page}
          sortBy={sortBy}
          sortOrder={sortOrder}
          lastListViewSort={lastListViewSort}
          rowsPerPage={rowsPerPage}
          changePageOrSort={changePageOrSort}
          selectedFolder = {selectedFolder}
        />:""}

      {emailModalVisible && !emailCreateViewLoading ? (<QuickComposeEmail
        subject={(emailModal && emailModal.name)?emailModal.name:''} body={(emailModal && emailModal.description_html)?emailModal.description_html:''} modalState={emailModalVisible} to_addrs_names={(emailModal && emailModal.to)?emailModal.to:''} cc_addrs_names={(emailModal && emailModal.cc)?emailModal.cc:''} bcc_addrs_names={(emailModal && emailModal.bcc)?emailModal.bcc:''} parent_name={{ 'parent_name': "", 'parent_id': "", 'parent_type': "" }}
        handleClose={() => { setEmailModalVisible(!emailModalVisible); }}
      />) : null}
      <EmailSettings
        open={emailSettingModal}
        handleClose={() => setEmailSettingModal(!emailSettingModal)}
      />
    </Page>
  );
};

export default Mail;
